import TimeUtils from '@shared/utils/time.utils';
import {
  RouteColorIcons,
  RouteColors,
  RouteNetworkMaintainerIconName,
  RouteNetworkMaintainerType,
} from '../constants/constants';
import { iconsMap } from '../constants/poi-icons';

export default class LayerColorUtils {
  static getRouteColorOrIcon(
    lastMaintainedUtc?: string,
    customerId?: number,
    returnIconFile = false,
  ): string {
    if (customerId === -1) {
      return returnIconFile ? RouteColorIcons.Level0 : RouteColors.Level7;
    }
    if (!lastMaintainedUtc) {
      return returnIconFile ? RouteColorIcons.Level7 : RouteColors.Level7;
    }

    const lastDate = TimeUtils.parseUTC(lastMaintainedUtc);
    const last = lastDate.getTime();
    const now = Date.now();

    if (isNaN(last)) {
      return returnIconFile ? RouteColorIcons.Level7 : RouteColors.Level7;
    }

    const diffMs = now - last;
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffDays = diffHours / 24;

    if (diffHours < 3) return returnIconFile ? RouteColorIcons.Level1 : RouteColors.Level1;
    if (diffHours < 12) return returnIconFile ? RouteColorIcons.Level2 : RouteColors.Level2;
    if (diffHours < 24) return returnIconFile ? RouteColorIcons.Level3 : RouteColors.Level3;
    if (diffHours < 48) return returnIconFile ? RouteColorIcons.Level4 : RouteColors.Level4;

    if (diffDays < 7) return returnIconFile ? RouteColorIcons.Level5 : RouteColors.Level5;
    if (diffDays < 15) return returnIconFile ? RouteColorIcons.Level6 : RouteColors.Level6;

    return returnIconFile ? RouteColorIcons.Level7 : RouteColors.Level7;
  }

  static getRouteMaintainerColorAndIconUrl(
    routeMaintainerType: RouteNetworkMaintainerType | undefined,
    lastPositionTimeUtc?: string,
  ): {
    color: string;
    iconUrl: string;
  } {
    const iconName =
      RouteNetworkMaintainerIconName[
        routeMaintainerType || RouteNetworkMaintainerType.TrailGroomer
      ];
    if (!lastPositionTimeUtc) {
      return { color: RouteColors.Level7, iconUrl: `./assets/${iconName}_sleep.svg` };
    }

    const lastDate = TimeUtils.parseUTC(lastPositionTimeUtc);
    const last = lastDate.getTime();
    const now = Date.now();

    if (isNaN(last)) {
      return { color: RouteColors.Level7, iconUrl: `./assets/${iconName}_sleep.svg` };
    }

    const diffMins = (now - last) / (1000 * 60);

    if (diffMins <= 15) {
      return { color: RouteColors.Level2, iconUrl: `./assets/${iconName}_active.svg` };
    }

    if (diffMins > 15 && diffMins <= 60) {
      return { color: RouteColors.Level6, iconUrl: `./assets/${iconName}_standby.svg` };
    }

    return { color: RouteColors.Level7, iconUrl: `./assets/${iconName}_sleep.svg` };
  }

  static getIconWithFill(iconName: string, color: string): string {
    const svg = iconsMap[iconName] ?? iconsMap['icon-info'];
    let withFill = svg.replace(/fill="[^"]*"/g, `fill="${color}"`);

    return withFill;
  }
}
